var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"card card-clean h-100"},[_c('div',{staticClass:"card-header bg-white border-0 fw-bold text-indigo h5"},[_vm._v(" 設備地圖 ")]),_c('div',{staticClass:"card-body p-2"},[_c('MapMap',{attrs:{"scenicAreaId":_vm.selectedScenicAreaId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }